/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { array } from 'prop-types';

import VideoEmbed from 'components/VideoEmbed/VideoEmbed';

import TextBlock from './TextBlock/TextBlock';
import CtaBlock from './CtaBlock/CtaBlock';
import DoubleCtaBlock from './DoubleCtaBlock/DoubleCtaBlock';
import GalleryBlock from './GalleryBlock/GalleryBlock';
import LogotypesBlock from './LogotypesBlock/LogotypesBlock';
import QuotesBlock from './QuotesBlock/QuotesBlock';
import TitleBlock from './TitleBlock/TitleBlock';
import BannerBlock from './BannerBlock/BannerBlock';
import ButtonsBlock from './ButtonsBlock/ButtonsBlock';
import ArticlesBlock from './ArticlesBlock/ArticlesBlock';
import NewsBlock from './NewsBlock/NewsBlock';

import styles from './section-blocks.scss';

/**
 * This is the section blocks component.
 *
 * @author Erwan Lemonnier
 */

export default class SectionBlocks extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    sections: array.isRequired,
  };

  renderSections() {
    const { sections } = this.props;

    if (!sections) {
      return null;
    }

    const blocks = sections.map(({ type, ...rest }, i) => {
      switch (type) {
        case 'text':
          return (
            <article className={styles.column} key={i}>
              <TextBlock {...rest} />
            </article>
          );

        case 'oembed':
          return (
            <article className={styles.column} key={i}>
              <VideoEmbed oembed={rest.url} fullscreen={false} />
            </article>
          );

        case 'gallery':
          return <GalleryBlock {...rest} key={i} />;

        case 'logotypes':
          return <LogotypesBlock {...rest} key={i} />;

        case 'cta':
          return <CtaBlock {...rest} key={i} />;

        case 'cta-right':
          return <CtaBlock {...rest} align="right" key={i} />;

        case 'cta-center':
          return <CtaBlock {...rest} align="center" key={i} />;

        case 'cta-double':
          return <DoubleCtaBlock {...rest} key={i} />;

        case 'quote':
          return <QuotesBlock {...rest} key={i} />;

        case 'title':
          return <TitleBlock {...rest} key={i} />;

        case 'banner':
          return <BannerBlock {...rest} key={i} />;

        case 'buttons':
          return <ButtonsBlock {...rest} key={i} />;

        case 'articles':
          return <ArticlesBlock {...rest} key={i} />;

        case 'news':
          return <NewsBlock {...rest} key={i} />;

        default:
          return null;
      }
    });

    return blocks;
  }

  render() {
    return this.renderSections();
  }
}
